/**
 * Generated by orval 🍺
 * Do not edit manually.
 * UK Fast Food Menus — Review
 * The HTTP contract of the UK Fast Food Menus review surface, generated from the Zod schemas its Express router validates against. The Admin_Panel menu-review and item-editor Bespoke_Pages compose this surface through the client generated from this document.
 * OpenAPI spec version: 0.1.0
 */
import type { CategoriseNewItem400 } from './model/categoriseNewItem400.js';

import type { CategoriseNewItem401 } from './model/categoriseNewItem401.js';

import type { CategoriseNewItem403 } from './model/categoriseNewItem403.js';

import type { CategoriseNewItem404 } from './model/categoriseNewItem404.js';

import type { CategoriseNewItem500 } from './model/categoriseNewItem500.js';

import type { CategoriseNewItemBody } from './model/categoriseNewItemBody.js';

import type { CorrectMenuItemAllergens400 } from './model/correctMenuItemAllergens400.js';

import type { CorrectMenuItemAllergens401 } from './model/correctMenuItemAllergens401.js';

import type { CorrectMenuItemAllergens403 } from './model/correctMenuItemAllergens403.js';

import type { CorrectMenuItemAllergens404 } from './model/correctMenuItemAllergens404.js';

import type { CorrectMenuItemAllergens500 } from './model/correctMenuItemAllergens500.js';

import type { CorrectMenuItemAllergensBody } from './model/correctMenuItemAllergensBody.js';

import type { CreateCategory201 } from './model/createCategory201.js';

import type { CreateCategory400 } from './model/createCategory400.js';

import type { CreateCategory401 } from './model/createCategory401.js';

import type { CreateCategory403 } from './model/createCategory403.js';

import type { CreateCategory500 } from './model/createCategory500.js';

import type { CreateCategoryBody } from './model/createCategoryBody.js';

import type { EditCategory400 } from './model/editCategory400.js';

import type { EditCategory401 } from './model/editCategory401.js';

import type { EditCategory403 } from './model/editCategory403.js';

import type { EditCategory404 } from './model/editCategory404.js';

import type { EditCategory500 } from './model/editCategory500.js';

import type { EditCategoryBody } from './model/editCategoryBody.js';

import type { EditMenuItemDisplay400 } from './model/editMenuItemDisplay400.js';

import type { EditMenuItemDisplay401 } from './model/editMenuItemDisplay401.js';

import type { EditMenuItemDisplay403 } from './model/editMenuItemDisplay403.js';

import type { EditMenuItemDisplay404 } from './model/editMenuItemDisplay404.js';

import type { EditMenuItemDisplay500 } from './model/editMenuItemDisplay500.js';

import type { EditMenuItemDisplayBody } from './model/editMenuItemDisplayBody.js';

import type { ListCategories200 } from './model/listCategories200.js';

import type { ListCategories400 } from './model/listCategories400.js';

import type { ListCategories401 } from './model/listCategories401.js';

import type { ListCategories403 } from './model/listCategories403.js';

import type { ListCategories500 } from './model/listCategories500.js';

import type { ListMenuItems200 } from './model/listMenuItems200.js';

import type { ListMenuItems400 } from './model/listMenuItems400.js';

import type { ListMenuItems401 } from './model/listMenuItems401.js';

import type { ListMenuItems403 } from './model/listMenuItems403.js';

import type { ListMenuItems500 } from './model/listMenuItems500.js';

import type { ListReviewQueue200 } from './model/listReviewQueue200.js';

import type { ListReviewQueue401 } from './model/listReviewQueue401.js';

import type { ListReviewQueue403 } from './model/listReviewQueue403.js';

import type { ListReviewQueue500 } from './model/listReviewQueue500.js';

import type { RemoveCategory400 } from './model/removeCategory400.js';

import type { RemoveCategory401 } from './model/removeCategory401.js';

import type { RemoveCategory403 } from './model/removeCategory403.js';

import type { RemoveCategory404 } from './model/removeCategory404.js';

import type { RemoveCategory500 } from './model/removeCategory500.js';

import type { RemoveCategoryBody } from './model/removeCategoryBody.js';

import type { ResolveReviewField400 } from './model/resolveReviewField400.js';

import type { ResolveReviewField401 } from './model/resolveReviewField401.js';

import type { ResolveReviewField403 } from './model/resolveReviewField403.js';

import type { ResolveReviewField404 } from './model/resolveReviewField404.js';

import type { ResolveReviewField500 } from './model/resolveReviewField500.js';

import type { ResolveReviewFieldBody } from './model/resolveReviewFieldBody.js';

import type { ResolveReviewImage400 } from './model/resolveReviewImage400.js';

import type { ResolveReviewImage401 } from './model/resolveReviewImage401.js';

import type { ResolveReviewImage403 } from './model/resolveReviewImage403.js';

import type { ResolveReviewImage404 } from './model/resolveReviewImage404.js';

import type { ResolveReviewImage500 } from './model/resolveReviewImage500.js';

import type { ResolveReviewImageBody } from './model/resolveReviewImageBody.js';

import type { ResolveSignificantChange400 } from './model/resolveSignificantChange400.js';

import type { ResolveSignificantChange401 } from './model/resolveSignificantChange401.js';

import type { ResolveSignificantChange403 } from './model/resolveSignificantChange403.js';

import type { ResolveSignificantChange404 } from './model/resolveSignificantChange404.js';

import type { ResolveSignificantChange500 } from './model/resolveSignificantChange500.js';

import type { ResolveSignificantChangeBody } from './model/resolveSignificantChangeBody.js';

import type { SetMenuItemNutrition400 } from './model/setMenuItemNutrition400.js';

import type { SetMenuItemNutrition401 } from './model/setMenuItemNutrition401.js';

import type { SetMenuItemNutrition403 } from './model/setMenuItemNutrition403.js';

import type { SetMenuItemNutrition404 } from './model/setMenuItemNutrition404.js';

import type { SetMenuItemNutrition500 } from './model/setMenuItemNutrition500.js';

import type { SetMenuItemNutritionBody } from './model/setMenuItemNutritionBody.js';

import type { UploadMenuItemImage200 } from './model/uploadMenuItemImage200.js';

import type { UploadMenuItemImage400 } from './model/uploadMenuItemImage400.js';

import type { UploadMenuItemImage401 } from './model/uploadMenuItemImage401.js';

import type { UploadMenuItemImage403 } from './model/uploadMenuItemImage403.js';

import type { UploadMenuItemImage404 } from './model/uploadMenuItemImage404.js';

import type { UploadMenuItemImage413 } from './model/uploadMenuItemImage413.js';

import type { UploadMenuItemImage415 } from './model/uploadMenuItemImage415.js';

import type { UploadMenuItemImage500 } from './model/uploadMenuItemImage500.js';

import type { UploadMenuItemImageBody } from './model/uploadMenuItemImageBody.js';

import { sendRequest } from '../api/request.js';
export type listCategoriesResponse200 = {
  data: ListCategories200;
  status: 200;
};

export type listCategoriesResponse400 = {
  data: ListCategories400;
  status: 400;
};

export type listCategoriesResponse401 = {
  data: ListCategories401;
  status: 401;
};

export type listCategoriesResponse403 = {
  data: ListCategories403;
  status: 403;
};

export type listCategoriesResponse500 = {
  data: ListCategories500;
  status: 500;
};

export type listCategoriesResponseSuccess = listCategoriesResponse200 & {
  headers: Headers;
};
export type listCategoriesResponseError = (
  | listCategoriesResponse400
  | listCategoriesResponse401
  | listCategoriesResponse403
  | listCategoriesResponse500
) & {
  headers: Headers;
};

export type listCategoriesResponse =
  listCategoriesResponseSuccess | listCategoriesResponseError;

export const getListCategoriesUrl = () => {
  return `/categories`;
};

/**
 * @summary List a restaurant's managed categories
 */
export const listCategories = async (
  options?: Parameters<typeof sendRequest>[1],
): Promise<listCategoriesResponse> => {
  return sendRequest<listCategoriesResponse>(getListCategoriesUrl(), {
    ...options,
    method: 'GET',
  });
};

export type createCategoryResponse201 = {
  data: CreateCategory201;
  status: 201;
};

export type createCategoryResponse400 = {
  data: CreateCategory400;
  status: 400;
};

export type createCategoryResponse401 = {
  data: CreateCategory401;
  status: 401;
};

export type createCategoryResponse403 = {
  data: CreateCategory403;
  status: 403;
};

export type createCategoryResponse500 = {
  data: CreateCategory500;
  status: 500;
};

export type createCategoryResponseSuccess = createCategoryResponse201 & {
  headers: Headers;
};
export type createCategoryResponseError = (
  | createCategoryResponse400
  | createCategoryResponse401
  | createCategoryResponse403
  | createCategoryResponse500
) & {
  headers: Headers;
};

export type createCategoryResponse =
  createCategoryResponseSuccess | createCategoryResponseError;

export const getCreateCategoryUrl = () => {
  return `/categories`;
};

/**
 * @summary Create a managed category for a restaurant
 */
export const createCategory = async (
  createCategoryBody: CreateCategoryBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<createCategoryResponse> => {
  return sendRequest<createCategoryResponse>(getCreateCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCategoryBody),
  });
};

export type editCategoryResponse204 = {
  data: void;
  status: 204;
};

export type editCategoryResponse400 = {
  data: EditCategory400;
  status: 400;
};

export type editCategoryResponse401 = {
  data: EditCategory401;
  status: 401;
};

export type editCategoryResponse403 = {
  data: EditCategory403;
  status: 403;
};

export type editCategoryResponse404 = {
  data: EditCategory404;
  status: 404;
};

export type editCategoryResponse500 = {
  data: EditCategory500;
  status: 500;
};

export type editCategoryResponseSuccess = editCategoryResponse204 & {
  headers: Headers;
};
export type editCategoryResponseError = (
  | editCategoryResponse400
  | editCategoryResponse401
  | editCategoryResponse403
  | editCategoryResponse404
  | editCategoryResponse500
) & {
  headers: Headers;
};

export type editCategoryResponse =
  editCategoryResponseSuccess | editCategoryResponseError;

export const getEditCategoryUrl = (categoryKey: string) => {
  return `/categories/${categoryKey}`;
};

/**
 * @summary Rename a managed category or set its icon
 */
export const editCategory = async (
  categoryKey: string,
  editCategoryBody: EditCategoryBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<editCategoryResponse> => {
  return sendRequest<editCategoryResponse>(getEditCategoryUrl(categoryKey), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(editCategoryBody),
  });
};

export type removeCategoryResponse204 = {
  data: void;
  status: 204;
};

export type removeCategoryResponse400 = {
  data: RemoveCategory400;
  status: 400;
};

export type removeCategoryResponse401 = {
  data: RemoveCategory401;
  status: 401;
};

export type removeCategoryResponse403 = {
  data: RemoveCategory403;
  status: 403;
};

export type removeCategoryResponse404 = {
  data: RemoveCategory404;
  status: 404;
};

export type removeCategoryResponse500 = {
  data: RemoveCategory500;
  status: 500;
};

export type removeCategoryResponseSuccess = removeCategoryResponse204 & {
  headers: Headers;
};
export type removeCategoryResponseError = (
  | removeCategoryResponse400
  | removeCategoryResponse401
  | removeCategoryResponse403
  | removeCategoryResponse404
  | removeCategoryResponse500
) & {
  headers: Headers;
};

export type removeCategoryResponse =
  removeCategoryResponseSuccess | removeCategoryResponseError;

export const getRemoveCategoryUrl = (categoryKey: string) => {
  return `/categories/${categoryKey}/remove`;
};

/**
 * @summary Remove a managed category
 */
export const removeCategory = async (
  categoryKey: string,
  removeCategoryBody: RemoveCategoryBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<removeCategoryResponse> => {
  return sendRequest<removeCategoryResponse>(
    getRemoveCategoryUrl(categoryKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(removeCategoryBody),
    },
  );
};

export type listMenuItemsResponse200 = {
  data: ListMenuItems200;
  status: 200;
};

export type listMenuItemsResponse400 = {
  data: ListMenuItems400;
  status: 400;
};

export type listMenuItemsResponse401 = {
  data: ListMenuItems401;
  status: 401;
};

export type listMenuItemsResponse403 = {
  data: ListMenuItems403;
  status: 403;
};

export type listMenuItemsResponse500 = {
  data: ListMenuItems500;
  status: 500;
};

export type listMenuItemsResponseSuccess = listMenuItemsResponse200 & {
  headers: Headers;
};
export type listMenuItemsResponseError = (
  | listMenuItemsResponse400
  | listMenuItemsResponse401
  | listMenuItemsResponse403
  | listMenuItemsResponse500
) & {
  headers: Headers;
};

export type listMenuItemsResponse =
  listMenuItemsResponseSuccess | listMenuItemsResponseError;

export const getListMenuItemsUrl = () => {
  return `/menu-items`;
};

/**
 * @summary List the published menu items of a restaurant
 */
export const listMenuItems = async (
  options?: Parameters<typeof sendRequest>[1],
): Promise<listMenuItemsResponse> => {
  return sendRequest<listMenuItemsResponse>(getListMenuItemsUrl(), {
    ...options,
    method: 'GET',
  });
};

export type correctMenuItemAllergensResponse204 = {
  data: void;
  status: 204;
};

export type correctMenuItemAllergensResponse400 = {
  data: CorrectMenuItemAllergens400;
  status: 400;
};

export type correctMenuItemAllergensResponse401 = {
  data: CorrectMenuItemAllergens401;
  status: 401;
};

export type correctMenuItemAllergensResponse403 = {
  data: CorrectMenuItemAllergens403;
  status: 403;
};

export type correctMenuItemAllergensResponse404 = {
  data: CorrectMenuItemAllergens404;
  status: 404;
};

export type correctMenuItemAllergensResponse500 = {
  data: CorrectMenuItemAllergens500;
  status: 500;
};

export type correctMenuItemAllergensResponseSuccess =
  correctMenuItemAllergensResponse204 & {
    headers: Headers;
  };
export type correctMenuItemAllergensResponseError = (
  | correctMenuItemAllergensResponse400
  | correctMenuItemAllergensResponse401
  | correctMenuItemAllergensResponse403
  | correctMenuItemAllergensResponse404
  | correctMenuItemAllergensResponse500
) & {
  headers: Headers;
};

export type correctMenuItemAllergensResponse =
  | correctMenuItemAllergensResponseSuccess
  | correctMenuItemAllergensResponseError;

export const getCorrectMenuItemAllergensUrl = (itemKey: string) => {
  return `/menu-items/${itemKey}/allergens`;
};

/**
 * @summary Correct a published item's extracted allergens
 */
export const correctMenuItemAllergens = async (
  itemKey: string,
  correctMenuItemAllergensBody: CorrectMenuItemAllergensBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<correctMenuItemAllergensResponse> => {
  return sendRequest<correctMenuItemAllergensResponse>(
    getCorrectMenuItemAllergensUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(correctMenuItemAllergensBody),
    },
  );
};

export type editMenuItemDisplayResponse204 = {
  data: void;
  status: 204;
};

export type editMenuItemDisplayResponse400 = {
  data: EditMenuItemDisplay400;
  status: 400;
};

export type editMenuItemDisplayResponse401 = {
  data: EditMenuItemDisplay401;
  status: 401;
};

export type editMenuItemDisplayResponse403 = {
  data: EditMenuItemDisplay403;
  status: 403;
};

export type editMenuItemDisplayResponse404 = {
  data: EditMenuItemDisplay404;
  status: 404;
};

export type editMenuItemDisplayResponse500 = {
  data: EditMenuItemDisplay500;
  status: 500;
};

export type editMenuItemDisplayResponseSuccess =
  editMenuItemDisplayResponse204 & {
    headers: Headers;
  };
export type editMenuItemDisplayResponseError = (
  | editMenuItemDisplayResponse400
  | editMenuItemDisplayResponse401
  | editMenuItemDisplayResponse403
  | editMenuItemDisplayResponse404
  | editMenuItemDisplayResponse500
) & {
  headers: Headers;
};

export type editMenuItemDisplayResponse =
  editMenuItemDisplayResponseSuccess | editMenuItemDisplayResponseError;

export const getEditMenuItemDisplayUrl = (itemKey: string) => {
  return `/menu-items/${itemKey}/display`;
};

/**
 * @summary Edit a published item's display fields
 */
export const editMenuItemDisplay = async (
  itemKey: string,
  editMenuItemDisplayBody: EditMenuItemDisplayBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<editMenuItemDisplayResponse> => {
  return sendRequest<editMenuItemDisplayResponse>(
    getEditMenuItemDisplayUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(editMenuItemDisplayBody),
    },
  );
};

export type uploadMenuItemImageResponse200 = {
  data: UploadMenuItemImage200;
  status: 200;
};

export type uploadMenuItemImageResponse400 = {
  data: UploadMenuItemImage400;
  status: 400;
};

export type uploadMenuItemImageResponse401 = {
  data: UploadMenuItemImage401;
  status: 401;
};

export type uploadMenuItemImageResponse403 = {
  data: UploadMenuItemImage403;
  status: 403;
};

export type uploadMenuItemImageResponse404 = {
  data: UploadMenuItemImage404;
  status: 404;
};

export type uploadMenuItemImageResponse413 = {
  data: UploadMenuItemImage413;
  status: 413;
};

export type uploadMenuItemImageResponse415 = {
  data: UploadMenuItemImage415;
  status: 415;
};

export type uploadMenuItemImageResponse500 = {
  data: UploadMenuItemImage500;
  status: 500;
};

export type uploadMenuItemImageResponseSuccess =
  uploadMenuItemImageResponse200 & {
    headers: Headers;
  };
export type uploadMenuItemImageResponseError = (
  | uploadMenuItemImageResponse400
  | uploadMenuItemImageResponse401
  | uploadMenuItemImageResponse403
  | uploadMenuItemImageResponse404
  | uploadMenuItemImageResponse413
  | uploadMenuItemImageResponse415
  | uploadMenuItemImageResponse500
) & {
  headers: Headers;
};

export type uploadMenuItemImageResponse =
  uploadMenuItemImageResponseSuccess | uploadMenuItemImageResponseError;

export const getUploadMenuItemImageUrl = (itemKey: string) => {
  return `/menu-items/${itemKey}/image`;
};

/**
 * @summary Upload a published item's image and store its public URL
 */
export const uploadMenuItemImage = async (
  itemKey: string,
  uploadMenuItemImageBody: UploadMenuItemImageBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<uploadMenuItemImageResponse> => {
  return sendRequest<uploadMenuItemImageResponse>(
    getUploadMenuItemImageUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(uploadMenuItemImageBody),
    },
  );
};

export type setMenuItemNutritionResponse204 = {
  data: void;
  status: 204;
};

export type setMenuItemNutritionResponse400 = {
  data: SetMenuItemNutrition400;
  status: 400;
};

export type setMenuItemNutritionResponse401 = {
  data: SetMenuItemNutrition401;
  status: 401;
};

export type setMenuItemNutritionResponse403 = {
  data: SetMenuItemNutrition403;
  status: 403;
};

export type setMenuItemNutritionResponse404 = {
  data: SetMenuItemNutrition404;
  status: 404;
};

export type setMenuItemNutritionResponse500 = {
  data: SetMenuItemNutrition500;
  status: 500;
};

export type setMenuItemNutritionResponseSuccess =
  setMenuItemNutritionResponse204 & {
    headers: Headers;
  };
export type setMenuItemNutritionResponseError = (
  | setMenuItemNutritionResponse400
  | setMenuItemNutritionResponse401
  | setMenuItemNutritionResponse403
  | setMenuItemNutritionResponse404
  | setMenuItemNutritionResponse500
) & {
  headers: Headers;
};

export type setMenuItemNutritionResponse =
  setMenuItemNutritionResponseSuccess | setMenuItemNutritionResponseError;

export const getSetMenuItemNutritionUrl = (itemKey: string) => {
  return `/menu-items/${itemKey}/nutrition`;
};

/**
 * @summary Set a published item's nutrition figures
 */
export const setMenuItemNutrition = async (
  itemKey: string,
  setMenuItemNutritionBody: SetMenuItemNutritionBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<setMenuItemNutritionResponse> => {
  return sendRequest<setMenuItemNutritionResponse>(
    getSetMenuItemNutritionUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setMenuItemNutritionBody),
    },
  );
};

export type listReviewQueueResponse200 = {
  data: ListReviewQueue200;
  status: 200;
};

export type listReviewQueueResponse401 = {
  data: ListReviewQueue401;
  status: 401;
};

export type listReviewQueueResponse403 = {
  data: ListReviewQueue403;
  status: 403;
};

export type listReviewQueueResponse500 = {
  data: ListReviewQueue500;
  status: 500;
};

export type listReviewQueueResponseSuccess = listReviewQueueResponse200 & {
  headers: Headers;
};
export type listReviewQueueResponseError = (
  | listReviewQueueResponse401
  | listReviewQueueResponse403
  | listReviewQueueResponse500
) & {
  headers: Headers;
};

export type listReviewQueueResponse =
  listReviewQueueResponseSuccess | listReviewQueueResponseError;

export const getListReviewQueueUrl = () => {
  return `/review-queue`;
};

/**
 * @summary List the review queue, filterable by restaurant
 */
export const listReviewQueue = async (
  options?: Parameters<typeof sendRequest>[1],
): Promise<listReviewQueueResponse> => {
  return sendRequest<listReviewQueueResponse>(getListReviewQueueUrl(), {
    ...options,
    method: 'GET',
  });
};

export type categoriseNewItemResponse204 = {
  data: void;
  status: 204;
};

export type categoriseNewItemResponse400 = {
  data: CategoriseNewItem400;
  status: 400;
};

export type categoriseNewItemResponse401 = {
  data: CategoriseNewItem401;
  status: 401;
};

export type categoriseNewItemResponse403 = {
  data: CategoriseNewItem403;
  status: 403;
};

export type categoriseNewItemResponse404 = {
  data: CategoriseNewItem404;
  status: 404;
};

export type categoriseNewItemResponse500 = {
  data: CategoriseNewItem500;
  status: 500;
};

export type categoriseNewItemResponseSuccess = categoriseNewItemResponse204 & {
  headers: Headers;
};
export type categoriseNewItemResponseError = (
  | categoriseNewItemResponse400
  | categoriseNewItemResponse401
  | categoriseNewItemResponse403
  | categoriseNewItemResponse404
  | categoriseNewItemResponse500
) & {
  headers: Headers;
};

export type categoriseNewItemResponse =
  categoriseNewItemResponseSuccess | categoriseNewItemResponseError;

export const getCategoriseNewItemUrl = (itemKey: string) => {
  return `/review-queue/${itemKey}/categorise`;
};

/**
 * @summary Categorise a new item and publish it
 */
export const categoriseNewItem = async (
  itemKey: string,
  categoriseNewItemBody: CategoriseNewItemBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<categoriseNewItemResponse> => {
  return sendRequest<categoriseNewItemResponse>(
    getCategoriseNewItemUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(categoriseNewItemBody),
    },
  );
};

export type resolveReviewFieldResponse204 = {
  data: void;
  status: 204;
};

export type resolveReviewFieldResponse400 = {
  data: ResolveReviewField400;
  status: 400;
};

export type resolveReviewFieldResponse401 = {
  data: ResolveReviewField401;
  status: 401;
};

export type resolveReviewFieldResponse403 = {
  data: ResolveReviewField403;
  status: 403;
};

export type resolveReviewFieldResponse404 = {
  data: ResolveReviewField404;
  status: 404;
};

export type resolveReviewFieldResponse500 = {
  data: ResolveReviewField500;
  status: 500;
};

export type resolveReviewFieldResponseSuccess =
  resolveReviewFieldResponse204 & {
    headers: Headers;
  };
export type resolveReviewFieldResponseError = (
  | resolveReviewFieldResponse400
  | resolveReviewFieldResponse401
  | resolveReviewFieldResponse403
  | resolveReviewFieldResponse404
  | resolveReviewFieldResponse500
) & {
  headers: Headers;
};

export type resolveReviewFieldResponse =
  resolveReviewFieldResponseSuccess | resolveReviewFieldResponseError;

export const getResolveReviewFieldUrl = (
  itemKey: string,
  field:
    | 'wheat'
    | 'rye'
    | 'barley'
    | 'oats'
    | 'spelt'
    | 'kamut'
    | 'soya'
    | 'nuts'
    | 'peanuts'
    | 'sesame'
    | 'milk'
    | 'eggs'
    | 'fish'
    | 'crustaceans'
    | 'celery'
    | 'sulphurDioxideAndSulphites'
    | 'mustard'
    | 'molluscs'
    | 'lupin'
    | 'energyKcal'
    | 'fatG'
    | 'saturatesG'
    | 'carbohydrateG'
    | 'sugarsG'
    | 'proteinG'
    | 'saltG'
    | 'name'
    | 'category',
) => {
  return `/review-queue/${itemKey}/fields/${field}`;
};

/**
 * @summary Accept or reject one changed field of a review item
 */
export const resolveReviewField = async (
  itemKey: string,
  field:
    | 'wheat'
    | 'rye'
    | 'barley'
    | 'oats'
    | 'spelt'
    | 'kamut'
    | 'soya'
    | 'nuts'
    | 'peanuts'
    | 'sesame'
    | 'milk'
    | 'eggs'
    | 'fish'
    | 'crustaceans'
    | 'celery'
    | 'sulphurDioxideAndSulphites'
    | 'mustard'
    | 'molluscs'
    | 'lupin'
    | 'energyKcal'
    | 'fatG'
    | 'saturatesG'
    | 'carbohydrateG'
    | 'sugarsG'
    | 'proteinG'
    | 'saltG'
    | 'name'
    | 'category',
  resolveReviewFieldBody: ResolveReviewFieldBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<resolveReviewFieldResponse> => {
  return sendRequest<resolveReviewFieldResponse>(
    getResolveReviewFieldUrl(itemKey, field),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resolveReviewFieldBody),
    },
  );
};

export type resolveReviewImageResponse204 = {
  data: void;
  status: 204;
};

export type resolveReviewImageResponse400 = {
  data: ResolveReviewImage400;
  status: 400;
};

export type resolveReviewImageResponse401 = {
  data: ResolveReviewImage401;
  status: 401;
};

export type resolveReviewImageResponse403 = {
  data: ResolveReviewImage403;
  status: 403;
};

export type resolveReviewImageResponse404 = {
  data: ResolveReviewImage404;
  status: 404;
};

export type resolveReviewImageResponse500 = {
  data: ResolveReviewImage500;
  status: 500;
};

export type resolveReviewImageResponseSuccess =
  resolveReviewImageResponse204 & {
    headers: Headers;
  };
export type resolveReviewImageResponseError = (
  | resolveReviewImageResponse400
  | resolveReviewImageResponse401
  | resolveReviewImageResponse403
  | resolveReviewImageResponse404
  | resolveReviewImageResponse500
) & {
  headers: Headers;
};

export type resolveReviewImageResponse =
  resolveReviewImageResponseSuccess | resolveReviewImageResponseError;

export const getResolveReviewImageUrl = (itemKey: string) => {
  return `/review-queue/${itemKey}/image`;
};

/**
 * @summary Accept or reject a review item's proposed image
 */
export const resolveReviewImage = async (
  itemKey: string,
  resolveReviewImageBody: ResolveReviewImageBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<resolveReviewImageResponse> => {
  return sendRequest<resolveReviewImageResponse>(
    getResolveReviewImageUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resolveReviewImageBody),
    },
  );
};

export type resolveSignificantChangeResponse204 = {
  data: void;
  status: 204;
};

export type resolveSignificantChangeResponse400 = {
  data: ResolveSignificantChange400;
  status: 400;
};

export type resolveSignificantChangeResponse401 = {
  data: ResolveSignificantChange401;
  status: 401;
};

export type resolveSignificantChangeResponse403 = {
  data: ResolveSignificantChange403;
  status: 403;
};

export type resolveSignificantChangeResponse404 = {
  data: ResolveSignificantChange404;
  status: 404;
};

export type resolveSignificantChangeResponse500 = {
  data: ResolveSignificantChange500;
  status: 500;
};

export type resolveSignificantChangeResponseSuccess =
  resolveSignificantChangeResponse204 & {
    headers: Headers;
  };
export type resolveSignificantChangeResponseError = (
  | resolveSignificantChangeResponse400
  | resolveSignificantChangeResponse401
  | resolveSignificantChangeResponse403
  | resolveSignificantChangeResponse404
  | resolveSignificantChangeResponse500
) & {
  headers: Headers;
};

export type resolveSignificantChangeResponse =
  | resolveSignificantChangeResponseSuccess
  | resolveSignificantChangeResponseError;

export const getResolveSignificantChangeUrl = (itemKey: string) => {
  return `/review-queue/${itemKey}/resolve`;
};

/**
 * @summary Confirm or reject a significant change
 */
export const resolveSignificantChange = async (
  itemKey: string,
  resolveSignificantChangeBody: ResolveSignificantChangeBody,
  options?: Parameters<typeof sendRequest>[1],
): Promise<resolveSignificantChangeResponse> => {
  return sendRequest<resolveSignificantChangeResponse>(
    getResolveSignificantChangeUrl(itemKey),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(resolveSignificantChangeBody),
    },
  );
};
